export const LOCALE_LOCALSTORAGE = 'hd_locale';
export const LOCALE_QUERYPARAM = 'locale';
export const DEFAULT_LANG = 'en_US';
